// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

import { z } from 'zod';

export const financialSituationSchema = z.object({
  q_income_level: z.enum([
    'income_lt_20k',
    'income_20k_60k',
    'income_60k_300k',
    'income_gt_300k',
  ]),
  q_salary_percentage: z.enum([
    'salary_pct_gt_75',
    'salary_pct_50_75',
    'salary_pct_25_50',
  ]),
  q_payment_obligations: z.enum([
    'obligations_gt_50',
    'obligations_35_50',
    'obligations_10_35',
    'obligations_lt_10',
  ]),
  q_liquidity_needs: z.enum([
    'need_funds_lt_6m',
    'need_funds_6m_2y',
    'need_funds_2_5y',
    'no_liquidity_need',
  ]),
  q_liquid_assets_ratio: z.enum([
    'liquid_assets_lt_25',
    'liquid_assets_25_50',
    'liquid_assets_50_75',
    'liquid_assets_gt_75',
  ]),
});

export type FinancialSituationFormData = z.infer<typeof financialSituationSchema>;
